import { __metadata } from 'tslib'

export interface PaginationMetadata {
    // offset: number
    // limit: number
    totalPages: number
    totalResults: number
    first: string
    last: string
    next: string 
    self: string
}

export interface Paginator<T> extends PaginationMetadata { }

export class Paginator<T> implements Paginator<T> {
    items: T[]
    meta: PaginationMetadata

    constructor (items: T[], meta: PaginationMetadata) {
        this.items = items
        this.meta = meta
    }

    get totalPages () {
        return this.meta.totalPages
    }

    get totalResults () {
        return this.meta.totalResults
    }

    get first () {
        return this.meta.first
    }
    
    get last () {
        return this.meta.last
    }

    get next () {
        return this.meta.next
    }
    
    get self () {
        return this.meta.self
    }
}
